exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e6913484] .vue-treeselect__control,[data-v-e6913484] .vue-treeselect__placeholder,[data-v-e6913484] .vue-treeselect__single-value{height:30px;line-height:30px}", ""]);

// exports
